import clsx from "clsx"
import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import { useGameTimer } from "@/hooks/useGameLogic"
import { useGame } from "@/providers/GameProvider"
import { Button, IButton } from "@/ui/Button"
import styles from "./ButtonTurn.module.scss"

interface IButtonTurn extends IButton {}

const ButtonTurnComponent: FC<IButtonTurn> = ({ className, ...rest }) => {
  const { t } = useTranslation()

  const { isMatchActive, isMyTurn, handleSkipMove } = useGame()
  const { remainingTurnSeconds } = useGameTimer()

  const handleClick = () => {
    if (isMyTurn) {
      handleSkipMove()
    }
  }

  return (
    <Button
      {...rest}
      className={clsx(styles.ButtonTurn, className)}
      styles={clsx("center", { "orange-3d": isMyTurn, green: !isMyTurn })}
      disabled={remainingTurnSeconds === 0 || !isMyTurn || !isMatchActive}
      onClick={handleClick}
    >
      <div>
        <span>
          {remainingTurnSeconds || 0}
          {t("second_short")}
        </span>{" "}
        {isMyTurn ? t("button.end") : t("rival.nominative")}
      </div>
    </Button>
  )
}

export const ButtonTurn = memo(ButtonTurnComponent)
